import { useMutation, useQueryClient } from '@tanstack/react-query';
import ReactGA from 'react-ga4';
import { putUsersMe } from '../../../../api/user/mutations/putUsersMe';
import { ampli } from '../../../../ampli';

export const usePutUsersMeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(putUsersMe, {
    onSuccess: (data, variables) => {
      if (variables?.reqBody?.advertisementTermsAgreement) {
        ampli.pvmSetAdConsent();
        ReactGA.event('pvm_set_ad_consent', {
          category: 'pvm',
          action: 'pvm_set_ad_consent',
        });
      }
      queryClient.invalidateQueries(['users_me']);
    },
  });
};
